"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3263],{

/***/ 87948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var components_Chip_LogoChip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90768);
/* harmony import */ var lib_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99601);
/* harmony import */ var components_Icon_IconStar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28939);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86880);
/* harmony import */ var components_Chip_Chip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5867);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41272);
/* harmony import */ var lib_host__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35304);
/* harmony import */ var components_Accordion_AccordionWithImage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92698);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56562);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40474);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61097);
/* harmony import */ var components_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9978);
/* harmony import */ var components_Icon_IconCheckCircle__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4110);
/* harmony import */ var modules_Business_Selection_cartStore__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(13084);
/* harmony import */ var components_Icon_IconPlusCircle__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(38445);
/* harmony import */ var components_Icon_IconPlayCircle__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14016);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(64078);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var components_Icon_IconLock__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97592);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(67832);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(59799);
/* harmony import */ var modules_Tenant_modalSectionStore__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(820);
























const VideoJS = next_dynamic__WEBPACK_IMPORTED_MODULE_19___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2544), __webpack_require__.e(9412), __webpack_require__.e(8289), __webpack_require__.e(1239), __webpack_require__.e(5491)]).then(__webpack_require__.bind(__webpack_require__, 57818)).then((mod)=>mod.VideoJS), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57818)
            ]
    },
    ssr: false
});
const Image = next_dynamic__WEBPACK_IMPORTED_MODULE_19___default()(()=>__webpack_require__.e(/* import() */ 2317).then(__webpack_require__.bind(__webpack_require__, 72317)).then((mod)=>mod.Image), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(72317)
            ]
    },
    ssr: false
});
const CardCourseBundle = ({ isUncheck =false , isHide =false , className ="" , isRow =false , isMyClass =false , isSquare =false , tracker , wrapClass ="" , isRecommendPage =false , onClickFunction , isModal =false , isBundles =false , previousCourse , courseIndex , ...props })=>{
    const isLocked = previousCourse && previousCourse?.enrollment_status !== "finished" && props.enrollment_status !== "finished";
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_22__/* .useIsDesktop */ .Ce)();
    const [chapters, setChapters] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [countLesson, setCountLesson] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [isLoading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [bundleImages, setBundleImages] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const institutionImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (props?.institution?.image_url) return props?.institution?.image_url;
        if (typeof props?.institution == "string" && (props?.institution).split("||").length > 1 && (props?.institution).split("||")[1].includes("https")) return (props?.institution).split("||")[1];
        if (typeof props?.institution == "object") return props?.institution?.image_url;
        return null;
    }, [
        props?.institution
    ]);
    const institutionName = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>props.institution?.name || props.institution?.split("||")[0] || "", [
        props.institution
    ]);
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("common");
    const isB2B = (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .useIsTenant */ .we)() || (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .useIsSubdomain */ .Do)();
    const isBusiness = !isB2B;
    const [isShow, isShowBundle, setIsShow, setIsShowBundle] = (0,modules_Tenant_modalSectionStore__WEBPACK_IMPORTED_MODULE_23__/* .useModalSectionStore */ .y)((state)=>[
            state.isShow,
            state.isShowBundle,
            state.setIsShow,
            state.setIsShowBundle
        ]);
    const isGokAresTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .isGokAresURL */ .a7)(window.location.hostname);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isRow && props?.chapters && props?.chapters.length) {
            setLoading(true);
            const newChapters = props?.chapters.map((el)=>{
                const allLesson = el?.lessons && el?.lessons.length ? el?.lessons.map((items)=>({
                        image: props?.image_cover_url,
                        course_slug: props.slug,
                        ...items
                    })) : [];
                return {
                    name: el.name,
                    image: props?.image_cover_url,
                    lessons: allLesson
                };
            });
            let counting = props?.chapters.flatMap((el)=>el?.lessons && el?.lessons.length);
            setCountLesson(counting.length);
            setChapters(newChapters);
            setLoading(false);
        }
    }, [
        props.chapters,
        isRow
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isBundles && props?.bundle_courses) {
            const images = props.bundle_courses.map((course)=>course.image_cover_url).filter(Boolean);
            setBundleImages(images);
        }
    }, [
        isBundles,
        props.bundle_courses
    ]);
    const events = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            event: "course_hover_a",
            property: {
                course_name: props?.name ?? "",
                course_slug: props?.slug ?? "",
                section_name: props?.sectionName ?? "",
                institution_name: props?.institution_name ?? props.institution?.name ?? "",
                index: props?.index ?? 0,
                page: `B2B Homepage`
            }
        }), [
        props
    ]);
    const [isHovering, setIsHovered] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [videoURL, setVideoURL] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [timeout, setModalTimeout] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [videoTimeout, setVideoTimeout] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setVideoURL(props?.bundle_courses?.[0]?.hover_content_url);
    }, [
        isHovering
    ]);
    const mouseEnterHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        timeout && clearTimeout(timeout);
        videoTimeout && clearTimeout(timeout);
        setModalTimeout(setTimeout(()=>{
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGTM */ .hk)({
                ...events
            });
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGA */ .w7)({
                ...events
            });
        }, 3000));
    // setVideoTimeout(
    //   setTimeout(() => {
    //     if (!isLocked) {
    //       setIsHovered(isHide ? false : true);
    //     }
    //   }, 500)
    // );
    }, [
        events,
        isHide,
        timeout,
        videoTimeout,
        isLocked
    ]);
    const mouseLeaveHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        timeout && clearTimeout(timeout);
        videoTimeout && clearTimeout(videoTimeout);
        setIsHovered(false);
    }, [
        timeout,
        videoTimeout
    ]);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const hasBusinessCourse = typeof router.query.hasBusinessCourse == "string" ? router.query.hasBusinessCourse : "false";
    const { loginState , currentUser  } = (0,modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_12__/* .useAuthStore */ .t)((state)=>({
            loginState: state.loginState,
            currentUser: state.currentUser
        }));
    const tenantJpTracker = currentUser?.tenant !== undefined && [
        "ppsdmaparatur",
        "menpan",
        "wonderfullearning",
        "kemkes",
        "tapinkab",
        "bssn",
        "bkpsdm-bekasikota",
        // "maluku-gate",
        // "trenggalekkab",
        "bpsdm-sumbar",
        "bpsdm-sulsel",
        "bpsdm-jambi",
        "bpsdmdki",
        // "jambikota",
        // "muarojambikab",
        // "pesawarankab",
        "batam",
        "pusdiklat-komdigi",
        "pusdiklat-kemenkeu",
        "kemenperin"
    ].includes((currentUser?.tenant)?.slug) || [
        "ppsdmaparatur",
        "menpan",
        "wonderfullearning",
        "kemkes",
        "tapinkab",
        "bssn",
        "bkpsdm-bekasikota",
        // "maluku-gate",
        // "trenggalekkab",
        "bpsdm-sumbar",
        "bpsdm-sulsel",
        "bpsdm-jambi",
        "bpsdmdki",
        // "jambikota",
        // "muarojambikab",
        // "pesawarankab",
        "batam",
        "pusdiklat-komdigi",
        "pusdiklat-kemenkeu",
        "kemenperin"
    ].includes(currentUser?.referral);
    const isSectionPage = router && router.pathname == "/section/[sectionSlug]";
    const isMyClassPage = router && router.pathname == "/my-class";
    const isSearchPage = typeof router.query.q == "string" ? router.query.q : null;
    const updateCart = (0,modules_Business_Selection_cartStore__WEBPACK_IMPORTED_MODULE_16__/* .useCartStore */ .x)((state)=>state.updateCart);
    // let content = () => null;
    const lengthOfText = props?.skills?.length > 0 ? props?.skills?.slice(0, 2).flatMap((el)=>el.name).join(" ").length : null;
    let index = isRow ? lengthOfText <= 100 ? 3 : 2 : 1;
    let lengthOfSkill = props?.skills?.length > index ? props?.skills?.length - index : null;
    const hasUserPaid = props.is_paid;
    const hasCertificate = props.has_certificate;
    const hasPaywall = props.is_paywall_enabled === undefined ? true : props.is_paywall_enabled;
    const isCourseFinished = props.enrollment_progress?.finished === props.enrollment_progress?.total;
    const isEnterprisePlus = currentUser?.tenant !== undefined && [
        "Enterprise Plus",
        "Pro Plus",
        `Pro Custom (${currentUser?.referral})`
    ].includes((currentUser?.tenant)?.plan?.name);
    let content = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>videoURL ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoJS, {
            isHovering: isHovering,
            url: videoURL,
            handleInterrupt: ()=>{}
        }) : null, [
        videoURL,
        isHovering
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: isRow && `flex items-center ${isDesktop ? "p-24 gap-20" : "p-12 gap-12"} ${props?.slug === router.query.courseSlug ? "bg-violet-10 border-l-4 border-violet_main" : isLocked && !isBundles ? "bg-light_neutral10_to_dark_neutral50" : ""}`,
        children: [
            isRow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-shrink-0 p-12 w-24 h-24 md:w-32 md:h-32 bg-white rounded-full border border-light_neutral20_to_dark_neutral60 flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-light_neutral-50 text-c1 md:text-b2",
                    children: courseIndex + 1
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `relative h-full w-full ${!isRow ? "cursor-pointer" : ""}`,
                onClick: onClickFunction ? ()=>{
                    if (!isLocked) {
                        onClickFunction();
                    }
                } : ()=>{
                    // Only allow actions if the previous course is finished
                    if (isLocked && !isBundles) return;
                    if (!isRow) {
                        setIsShow(false);
                        setIsShowBundle(false);
                        if (props.onSelect) {
                            updateCart(props);
                        } else {
                            router.push(loginState == "LOGIN" ? isRecommendPage ? {
                                pathname: "/r/[page]",
                                query: {
                                    page: `/course/${props.slug}`
                                }
                            } : {
                                pathname: "/course/[courseSlug]",
                                query: {
                                    ...router.query,
                                    courseSlug: isBundles ? props?.bundle_courses?.[0]?.slug : props.slug,
                                    ...isBundles && {
                                        bundleSlug: props?.slug
                                    }
                                }
                            } : {
                                pathname: "/login",
                                query: {
                                    url: isBundles ? encodeURIComponent(`/course/${props?.bundle_courses?.[0]?.slug}?bundleSlug=${props.slug}`) : encodeURIComponent(`/course/${props.slug}`)
                                }
                            });
                        }
                    }
                    if (tracker) {
                        (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGTM */ .hk)(tracker);
                        (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGA */ .w7)(tracker);
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: `flex gap-8 h-fit ${isRow ? `w-full ${!isDesktop ? "flex-row items-center" : "flex-col md:flex-row"}` : "flex-col"}`,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: `relative
           overflow-hidden md-max:flex- aspect-[16/9] ${isHovering ? "" : isSquare ? "" : "rounded-8"} ${isRow ? `md:w-[40%] ${isDesktop ? "w-full" : "w-[60%]"} h-full` : `${wrapClass} h-[200px] md:h-full`}`,
                            onMouseEnter: mouseEnterHandler,
                            onMouseLeave: mouseLeaveHandler,
                            onClick: ()=>{
                                if (isLocked && !isBundles) return;
                                if (isRow) {
                                    setIsShow(false);
                                    setIsShowBundle(false);
                                    router.push(loginState == "LOGIN" ? {
                                        pathname: "/course/[courseSlug]",
                                        query: {
                                            ...router.query,
                                            courseSlug: props?.slug
                                        }
                                    } : {
                                        pathname: "/login",
                                        query: {
                                            url: encodeURIComponent(`/course/${props?.slug}`)
                                        }
                                    });
                                }
                                if (tracker) {
                                    (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGTM */ .hk)(tracker);
                                    (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_8__/* .trackEventGA */ .w7)(tracker);
                                }
                            },
                            children: [
                                (!isHovering || !props?.hover_content_url) && !isBundles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: props.image_cover_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_21___default()), {
                                        priority: true,
                                        fetchPriority: "high",
                                        alt: props.name,
                                        src: props.image_cover_url,
                                        width: 305,
                                        height: 150,
                                        "data-testid": "card-featured_cover",
                                        className: `object-cover w-full h-full object-center flex-shrink-0 ${isHovering ? "" : isSquare ? "" : "rounded-8"}`
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: `bg-neutral-20 w-full aspect-[16/9] flex-shrink-0 ${isRow ? "h-full" : "md:full"} ${isSquare ? "" : "rounded-8"}`
                                    })
                                }),
                                (!isHovering || !props?.bundle_courses?.[0]?.hover_content_url) && isBundles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: props?.bundle_courses?.[0]?.image_cover_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_21___default()), {
                                        priority: true,
                                        fetchPriority: "high",
                                        alt: props.name,
                                        src: props?.bundle_courses?.[0]?.image_cover_url,
                                        width: 305,
                                        height: 150,
                                        "data-testid": "card-featured_cover",
                                        className: `object-cover w-full h-full object-center ${isHovering ? "" : isSquare ? "" : "rounded-8"}`
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: `bg-neutral-20 w-full aspect-[16/9] ${isRow ? "h-full" : "md:full"} ${isSquare ? "" : "rounded-8"}`
                                    })
                                }),
                                isBusiness && router.pathname == "/pilih-kursus" && !isUncheck && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-0 w-full h-full flex justify-end items-start p-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconPlusCircle__WEBPACK_IMPORTED_MODULE_17__/* .IconPlusCircle */ .O, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-0 w-full h-full",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-full flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconPlayCircle__WEBPACK_IMPORTED_MODULE_18__/* .IconPlayCircle */ .U, {
                                            size: isDesktop ? 45 : 24,
                                            classes: "m-auto",
                                            isBgCustomized: true
                                        })
                                    })
                                }),
                                isLocked && !isBundles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: `absolute top-0 w-full h-full aspect-16/9 bg-black_to_black/60 z-[3] ${isSquare ? "" : "rounded-8"}`
                                }),
                                isHovering && (isBundles && props?.bundle_courses?.[0]?.hover_content_url || !isBundles && props?.hover_content_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full h-full",
                                    children: content()
                                }),
                                isHide && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-0 bg-[#00000099] w-full h-full flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-b1 font-black text-white",
                                        children: "Khusus goKampus Business"
                                    })
                                }),
                                isBundles && !isHovering && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "absolute bottom-4 right-4 w-[85px] h-[48px]",
                                    children: [
                                        bundleImages.slice(0, 3).map((img, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                                                src: img,
                                                alt: `background-${idx}`,
                                                className: `absolute border border-white_to_white w-full h-full object-cover rounded-8 shadow-md transition-all duration-300 ${idx === 0 ? "z-10" : "z-[8]"}`,
                                                style: {
                                                    zIndex: 8 - idx,
                                                    transform: idx === 0 ? "none" : `translate(-${idx * 6}px, -${idx * 6}px)`
                                                }
                                            }, idx)),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute border border-white_to_white inset-0 bg-black_to_black/40 backdrop-blur-lg z-10 rounded-8 flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "text-white_to_white font-medium text-c1",
                                                children: [
                                                    props?.bundle_courses?.length,
                                                    "+ Kursus"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                !isBundles && props?.course_available_until && props?.course_available_until !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-12 right-12 w-full h-full flex justify-end items-end",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center justify-center gap-[4px] bg-[#FAE7EC] text-[#D0375C] px-[8px] py-[4px] rounded-full",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/warning.png",
                                                className: "w-[20px] h-[20px]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm font-thin",
                                                children: t("endingSoon")
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        isRow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: `flex flex-col gap-12 ${isSquare ? "w-[90%] mx-auto" : `${isDesktop ? "w-full" : "w-[40%]"} md:w-[60%]`}`,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: `overflow-hidden ${!isHovering ? "rounded-b-12" : ""}`,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: `gap-8 relative text-neutral80_to_dark10 items-center`,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: `flex flex-col justify-between gap-4 md:gap-8 ${!isLocked ? "cursor-pointer" : "cursor-not-allowed"}`,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "md:hidden text-c1 md:text-b2 font-light max-w-full truncate text-neutral80_to_dark10 text-left",
                                                    children: institutionName
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_11___default()), {
                                                    // @ts-ignore
                                                    href: isLocked && !isBundles ? "#" : hasBusinessCourse === "true" ? "https://business.gokampus.com/hubungi-sales" : loginState == "LOGIN" ? isRecommendPage ? {
                                                        pathname: "/r/[page]",
                                                        query: {
                                                            page: `/course/${props.slug}`
                                                        }
                                                    } : {
                                                        pathname: "/course/[courseSlug]",
                                                        query: isSectionPage ? {
                                                            ...router.query,
                                                            courseSlug: props?.slug,
                                                            institutionKey: `${props?.institution.slug}`,
                                                            hasBusinessCourse: props?.institution.is_business,
                                                            institutionName: `${props?.institution.name}||${props?.institution.image_url}`
                                                        } : props?.is_institution_business ? {
                                                            ...router.query,
                                                            courseSlug: props?.slug,
                                                            institutionKey: props?.institution,
                                                            hasBusinessCourse: props?.is_institution_business,
                                                            institutionName: `${props?.institution.name}||${props?.institution.image_url}`
                                                        } : {
                                                            ...router.query,
                                                            courseSlug: props?.slug
                                                        }
                                                    } : {
                                                        pathname: "/login",
                                                        query: isSectionPage ? {
                                                            url: encodeURIComponent(`/course/${props?.slug}?institutionKey=${props?.institution.slug}&hasBusinessCourse=${props?.institution.is_business}&institutionName=${props?.institution.name}||${props?.institution.image_url}`)
                                                        } : {
                                                            url: encodeURIComponent(`/course/${props?.slug}?institutionKey=${props?.institution}&hasBusinessCourse=${props?.is_institution_business}`)
                                                        }
                                                    },
                                                    passHref: hasBusinessCourse === "true",
                                                    onClick: (e)=>{
                                                        if (isLocked && !isBundles) {
                                                            e.preventDefault();
                                                            return;
                                                        } else {
                                                            setIsShow(false);
                                                            setIsShowBundle(false);
                                                        }
                                                    },
                                                    rel: hasBusinessCourse === "true" ? "noopener noreferrer" : "",
                                                    target: hasBusinessCourse === "true" ? "_blank" : "",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                        className: `text-b2 md:text-b1 font-medium max-w-full text-neutral-80 text-left ` + (isMyClassPage ? "line-clamp-1" : "line-clamp-2"),
                                                        children: [
                                                            isBundles ? props.title : props.name,
                                                            " ",
                                                            (tenantJpTracker || isGokAresTenant) && !isBundles && isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "text-violet_main_to_dark_purple_surface",
                                                                children: [
                                                                    "(",
                                                                    props?.learning_hours,
                                                                    " JP)"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, props?.name + index),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex gap-8 items-center md-max:hidden",
                                                    children: [
                                                        institutionImage && isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_LogoChip__WEBPACK_IMPORTED_MODULE_2__/* .LogoChip */ .E, {
                                                            image_url: institutionImage,
                                                            size: 36,
                                                            useResizeImage: true,
                                                            styles: "border border-neutral20_to_dark30"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "grid gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "text-c1 md:text-b2 font-light max-w-full truncate text-neutral80_to_dark10 text-left",
                                                                    children: institutionName
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "flex gap-8 justify-start items-center text-b2 text-neutral80_to_dark10 font-light",
                                                                    children: [
                                                                        typeof props?.review_summary?.star_avg === "number" && props?.review_summary?.star_avg !== 0 && !isB2B && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "flex items-center justify-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconStar__WEBPACK_IMPORTED_MODULE_4__/* .IconStar */ .G, {
                                                                                            size: 14,
                                                                                            fill: true,
                                                                                            color: "#EFB443"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                            className: "ml-2 text-b2",
                                                                                            children: (0,lib_helper__WEBPACK_IMPORTED_MODULE_3__/* .formatRating */ .A6)(props?.review_summary?.star_avg.toFixed(1))
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                "|"
                                                                            ]
                                                                        }),
                                                                        props.total_learners !== 0 && !isB2B && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            children: `${(0,lib_helper__WEBPACK_IMPORTED_MODULE_3__/* .numberWithCommas */ .x6)(props.total_learners)} ${t("pelajar").toLowerCase()}`
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: props.skills?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: `opacity-100 transition-opacity duration-[1000ms] ease-in-out`,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-wrap gap-12 items-center",
                                            children: [
                                                props?.skills?.slice(0, index).map((skill)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_Chip__WEBPACK_IMPORTED_MODULE_6__/* .Chip */ .A, {
                                                        className: (isModal ? "bg-light_neutral10_to_dark_neutral50" : "") + " text-neutral80_to_dark10 font-light text-b2",
                                                        children: skill.name || skill.toString()
                                                    }, skill.slug)),
                                                lengthOfSkill >= 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "text-neutral80_to_dark10 text-b2 font-light",
                                                    children: [
                                                        "+",
                                                        lengthOfSkill,
                                                        " Skill lainnya"
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : null
                                }),
                                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "line-clamp-2 text-neutral-70 font-light text-b2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: props?.description
                                        }
                                    })
                                }),
                                isLoading && chapters.length == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Skeleton_Skeleton__WEBPACK_IMPORTED_MODULE_14__/* .SkeletonRect */ .a8, {
                                    className: "w-full h-[76px] rounded-8"
                                }) : !isLoading && chapters.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Accordion_AccordionWithImage__WEBPACK_IMPORTED_MODULE_10__/* .AccordionWithImage */ .H, {
                                    className: "bg-slated_purple rounded-8 p-8",
                                    data: chapters,
                                    countLesson: countLesson
                                }) : null
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: `overflow-hidden flex gap-8 ${!isHovering ? "rounded-b-12" : ""} ${isSquare ? "w-[90%] mx-auto" : "w-full m-0"}`,
                                children: [
                                    !isBundles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex justify-center items-start",
                                        children: institutionImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_LogoChip__WEBPACK_IMPORTED_MODULE_2__/* .LogoChip */ .E, {
                                            image_url: institutionImage,
                                            size: 36,
                                            useResizeImage: true,
                                            styles: "border border-neutral20_to_dark30"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-8 w-[-webkit-fill-available]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                                className: `text-b1 font-medium max-w-full text-neutral-80 text-left ` + (isMyClassPage ? "line-clamp-1" : "line-clamp-2"),
                                                children: [
                                                    isBundles ? props.title : props.name,
                                                    " ",
                                                    (tenantJpTracker || isGokAresTenant) && !isBundles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                        className: "text-violet_main_to_dark_purple_surface",
                                                        children: [
                                                            "(",
                                                            props?.learning_hours,
                                                            " JP)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !isBundles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-b2 font-light max-w-full truncate text-neutral80_to_dark10 text-left",
                                                children: institutionName
                                            }),
                                            isBundles ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: props?.bundle_courses?.[0]?.skills?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: `opacity-100 transition-opacity duration-[1000ms] ease-in-out`,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex flex-wrap gap-12 items-center",
                                                        children: [
                                                            props?.bundle_courses?.[0]?.skills?.slice(0, index).map((skill)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_Chip__WEBPACK_IMPORTED_MODULE_6__/* .Chip */ .A, {
                                                                    className: (isModal ? "bg-light_neutral10_to_dark_neutral50" : "") + " text-neutral80_to_dark10 font-light text-b2",
                                                                    children: skill.name || skill.toString()
                                                                }, skill.slug)),
                                                            lengthOfSkill >= 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "text-neutral80_to_dark10 text-b2 font-light",
                                                                children: [
                                                                    "+",
                                                                    lengthOfSkill,
                                                                    " Skill lainnya"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : null
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: props.skills?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: `opacity-100 transition-opacity duration-[1000ms] ease-in-out`,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex flex-wrap gap-12 items-center",
                                                        children: [
                                                            props?.skills?.slice(0, index).map((skill)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Chip_Chip__WEBPACK_IMPORTED_MODULE_6__/* .Chip */ .A, {
                                                                    className: (isModal ? "bg-light_neutral10_to_dark_neutral50" : "") + " text-neutral80_to_dark10 font-light text-b2",
                                                                    children: skill.name || skill.toString()
                                                                }, skill.slug)),
                                                            lengthOfSkill >= 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "text-neutral80_to_dark10 text-b2 font-light",
                                                                children: [
                                                                    "+",
                                                                    lengthOfSkill,
                                                                    " Skill lainnya"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : null
                                            }),
                                            isMyClass && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-col items-center gap-8 py-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "w-full h-6 bg-light_neutral10_to_dark_neutral50 rounded-full overflow-hidden relative",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: `rounded-full h-full ${isCourseFinished ? "bg-green-70" : "bg-violet_main_to_dark_purple_surface"}`,
                                                                style: {
                                                                    width: props.enrollment_progress.finished / props.enrollment_progress.total * 100 + "%"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: `w-full flex items-center justify-between text-b2 ${isCourseFinished ? "text-green-70 font-light text-b2" : "text-violet_main_to_dark_purple_surface font-light"}`,
                                                            children: [
                                                                isCourseFinished ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Selesai"
                                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                    children: [
                                                                        props.enrollment_progress?.finished,
                                                                        "/",
                                                                        t("totalLesson", {
                                                                            count: props.enrollment_progress?.total,
                                                                            additionalS: props.enrollment_progress?.total > 1 ? "s" : ""
                                                                        })
                                                                    ]
                                                                }),
                                                                hasPaywall && !hasUserPaid && isCourseFinished && // (isEnterprisePlus || hasCertificate) ? (
                                                                // remove validate OR
                                                                isEnterprisePlus && hasCertificate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                    variant: "primary_outlined",
                                                                    size: "medium",
                                                                    className: "!p-0",
                                                                    children: t("downloadCertif")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        props.isChecked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute bg-[#0d0d0d80] top-0 rounded-8 w-full h-full p-8 flex justify-end items-start",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconCheckCircle__WEBPACK_IMPORTED_MODULE_15__/* .IconCheckCircle */ .B, {})
                        }) : null
                    ]
                })
            }),
            isRow && (props?.enrollment_status === "finished" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[24px] h-[24px] flex justify-center items-center flex-shrink-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_21___default()), {
                    alt: "check",
                    src: "/images/check-circle.svg",
                    width: 24,
                    height: 24
                })
            }) : isLocked && !isBundles ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[24px] h-[24px] flex justify-center items-center flex-shrink-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconLock__WEBPACK_IMPORTED_MODULE_20__/* .IconLock */ ._, {
                    size: 24
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[24px] h-[24px] flex justify-center items-center flex-shrink-0"
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardCourseBundle);


/***/ }),

/***/ 82084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qs": function() { return /* binding */ useBundleStatus; },
/* harmony export */   "U8": function() { return /* binding */ useBundleEnroll; },
/* harmony export */   "jQ": function() { return /* binding */ useBundleDetail; },
/* harmony export */   "mK": function() { return /* binding */ useGetBundleByTenantSlug; },
/* harmony export */   "mP": function() { return /* binding */ useGetBundleByTenantSlugAndSlug; }
/* harmony export */ });
/* unused harmony export useBundleList */
/* harmony import */ var lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49208);

const useBundleList = ()=>useApi("get", "/bundles");
const useBundleDetail = (bundleSlug)=>// @ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/bundles/{slug}", bundleSlug);
// @ts-ignore
const useBundleEnroll = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("post", "/bundles/{slug}/enroll");
// @ts-ignore
const useBundleStatus = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/bundles/{slug}/status");
const useGetBundleByTenantSlug = ()=>// @ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/tenants/{slug}/bundles");
const useGetBundleByTenantSlugAndSlug = ()=>// @ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/tenants/{slug}/bundles/{bundle_slug}");


/***/ })

}]);